import React, { useCallback, useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import API from '../services/api';
import { useAuth } from '../context/AuthContext';

const POLL_MS = 60 * 1000;
const listeners = new Set();

// Anything that just changed a conversation (the inbox) can ask the badge to re-count at once.
export const refreshWhatsAppBadge = () => listeners.forEach(fn => fn());

// Header button for the WhatsApp inbox, with the number of conversations waiting for a person. Hidden until WhatsApp
// is configured on the server, so it doesn't take header room before the line exists. Same refresh triggers as the
// other header badges (route change, window focus, every minute).
const WhatsAppBadge = () => {
  const { isLoggedIn, mustChangePassword } = useAuth();
  const location = useLocation();
  const [summary, setSummary] = useState(null);

  const refresh = useCallback(async () => {
    if (!isLoggedIn || mustChangePassword || !localStorage.getItem('token')) { setSummary(null); return; }
    try { setSummary((await API.get('/whatsapp-inbox/summary', { silent: true })).data); } catch (err) { /* next tick */ }
  }, [isLoggedIn, mustChangePassword]);

  useEffect(() => { refresh(); }, [refresh, location.pathname]);
  useEffect(() => {
    const timer = setInterval(refresh, POLL_MS);
    window.addEventListener('focus', refresh);
    listeners.add(refresh);
    return () => { clearInterval(timer); window.removeEventListener('focus', refresh); listeners.delete(refresh); };
  }, [refresh]);

  if (!summary?.configured) return null;
  return (
    <NavLink to="/whatsapp" className={({ isActive }) => `btn btn-outline-secondary btn-sm approvals-bell${isActive ? ' active' : ''}`}
      title="WhatsApp: conversaciones que esperan a una persona" aria-label="WhatsApp">
      <i className="bi bi-whatsapp" />
      {summary.waiting > 0 && <span className="approvals-badge">{summary.waiting > 99 ? '99+' : summary.waiting}</span>}
    </NavLink>
  );
};

export default WhatsAppBadge;
